import { render, staticRenderFns } from "./PreFooter.vue?vue&type=template&id=bf136cba&scoped=true"
import script from "./PreFooter.vue?vue&type=script&lang=js"
export * from "./PreFooter.vue?vue&type=script&lang=js"
import style0 from "./PreFooter.vue?vue&type=style&index=0&id=bf136cba&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf136cba",
  null
  
)

export default component.exports